import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAction } from "src/models/Maintenance/Action.models";

interface ActionState {
  actions: IAction[];
  actionToEdit: IAction | null;
}

const initialState: ActionState = {
  actions: [],
  actionToEdit: null,
};

const actionSlice = createSlice({
  name: "Action",
  initialState,
  reducers: {
    setActionList: (state, action: PayloadAction<IAction[]>) => {
      state.actions = action.payload;
    },
    concatListAction: (
      state: ActionState,
      action: PayloadAction<IAction[]>
    ) => {
      state.actions = [...state.actions.concat(action.payload)];
    },
    setActionToEdit: (state, action: PayloadAction<IAction | null>) => {
      state.actionToEdit = action.payload;
    },
    addAction: (state, action: PayloadAction<IAction>) => {
      state.actions.push(action.payload);
    },
    updateAction: (state, action: PayloadAction<IAction>) => {
      let itemIndex = state.actions.findIndex(
        item => item.actionId === action.payload.actionId
      );
      if (itemIndex !== -1) state.actions[itemIndex] = action.payload;
    },
    deleteAction: (state, action: PayloadAction<number>) => {
      const newArray = state.actions.filter(
        item => item.actionId !== action.payload
      );
      state.actions = newArray;
    },
  },
});

export const {
  setActionList,
  concatListAction,
  setActionToEdit,
  addAction,
  updateAction,
  deleteAction,
} = actionSlice.actions;

export default actionSlice.reducer;
